import { CompanyIcon } from '@/components/CompanyIcon';
import { CountryFlag } from '@/components/CountryFlag';
import type { ISO2 } from '@/constants/countries';

type Props = {
  canonicalUrl: string;
  onCompanySelect: (canonicalUrl: string) => void;
  tickerSymbol: string;
  url: string | undefined | null;
  name: string;
  countryIso2: ISO2 | null;
};

export const NarrativeMiniValuatorHighlightedCompanyButton = ({
  canonicalUrl,
  onCompanySelect,
  tickerSymbol,
  url,
  name,
  countryIso2,
}: Props) => {
  return (
    <button
      key={canonicalUrl}
      type="button"
      onClick={() => onCompanySelect(canonicalUrl)}
      className="focus-outline grid grid-cols-[theme(spacing.x5)_auto] items-center gap-x1_5 overflow-x-hidden rounded-x1 p-x1 duration-150 hover:bg-surface-3"
    >
      <CompanyIcon size={40} tickerSymbol={tickerSymbol} website={url} />

      <div className="grid">
        <div className="truncate text-left text-sm font-strong text-solid">
          <span className="sr-only">Select </span>
          {name}
        </div>
        <div className="grid grid-cols-[theme(spacing.x3)_auto] items-center">
          <CountryFlag countryISO={countryIso2} />
          <div className="truncate text-left text-tiny text-soft">
            {tickerSymbol}
          </div>
        </div>
      </div>
    </button>
  );
};
